<template>
  <v-card-text>
    <v-switch
      :label="`${$t('schema.builder.inputs.options.required')}`"
      :input-value="options.required"
      @change="update({required: $event})"
    ></v-switch>
    <v-switch
        :input-value="options.keyboardInputMode"
        label="Domyślnie wprowadzaj czas/godzinę za pomocą klawiatury (aplikacja mobilna)"
        @change="update({keyboardInputMode: $event})"
    ></v-switch>
  </v-card-text>
</template>
<script>
import options from "@/mixins/options"

export default {
  name: "time-options",
  mixins: [ options ]
}
</script>
<style>
</style>
